export default "__VITE_ASSET__BkqS11r6__"